import { formatDate } from '@angular/common';
import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import moment from 'moment';
import { AuthenticationService } from '../../../core/http/authentication.service';
import { VersionCheckerService } from '../../../core/services/version-checker.service';
import { DashboardCardComponent } from '../../dashboard/dashboardcard.component';

@Component({
  selector: 'bpw-urp-dashboardcard',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './urp-dashboardcard.component.html',
  styleUrls: ['./urp-dashboardcard.component.scss'],
})
export class UrpDashboardcardComponent implements DashboardCardComponent, OnInit {
  private readonly _authService = inject(AuthenticationService);
  private readonly _versionCheckerService = inject(VersionCheckerService);

  @Input()
  public data: any;
  public visible: boolean;

  readonly hasMiUser = signal(false);
  readonly hasUrpUser = signal(false);
  readonly miName = signal('');
  readonly showUrpStatistik = signal(false);
  readonly currentDatum = signal('');
  readonly currentJahr = signal(0);

  constructor() {
    this.visible = false;
  }

  ngOnInit(): void {
    this.hasMiUser.set(this._authService.currentUserValue?.hasMiUser ?? false);
    this.hasUrpUser.set(this._authService.currentUserValue?.hasUrpUser ?? false);
    this.miName.set(this._authService.currentUserValue?.miName ?? '');
    this.showUrpStatistik.set(this._versionCheckerService.hasRequiredBauplusVersion('10.36.30.0'));

    this.currentDatum.set(formatDate(new Date(), 'yyyy-MM-dd', 'en'));
    this.currentJahr.set(moment().year());
  }
}
